var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBox2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gezulbugea",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ga54m9qxsb",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2ocbn4fh8c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#004CC4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#gezulbugea)",
    d: "M31.28 13.57l7.439-4.096c-.297-.288-.653-.517-1.088-.747L23.665 1.034C22.458.364 21.252 0 20.085 0c-1.187 0-2.394.364-3.6 1.034l-4.016 2.2L31.28 13.57z",
    transform: "translate(-249 -301) translate(165 301) translate(84) translate(.313)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ga54m9qxsb)",
    d: "M20.489 19.385l8.386-4.594L10.276 4.523 3.07 8.49c-.432.228-.786.455-1.1.74l18.52 10.155z",
    transform: "translate(-249 -301) translate(165 301) translate(84) translate(.313)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#2ocbn4fh8c)",
    d: "M21.656 42c.136-.039.253-.097.389-.175l15.209-8.671c1.806-1.03 2.777-2.08 2.777-4.9V13.108c0-.583-.038-1.05-.155-1.477l-18.22 10.421V42zM18.375 42V22.052L.155 11.631C.04 12.058 0 12.525 0 13.108v15.146c0 2.82.99 3.87 2.778 4.9l15.228 8.671c.116.078.233.136.369.175z",
    transform: "translate(-249 -301) translate(165 301) translate(84) translate(.313)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBox2);
export default __webpack_public_path__ + "static/media/icon-box-2.8cc0511b.svg";
export { ForwardRef as ReactComponent };